// extracted by mini-css-extract-plugin
module.exports = {"banner":"PdpRespPreviewMessageBanner__banner__9eec6e32","printLink":"PdpRespPreviewMessageBanner__printLink__9eec6e32"};